// extracted by mini-css-extract-plugin
module.exports = {"notifications-area":"notifications_notifications-area__Kd34a","toast":"notifications_toast__X2a2w","progress":"notifications_progress__E_gQP"};